/**
 * SNT Collections grid — tabbed collection fetch + AJAX add to cart
 * Prices: Shopify /products.json uses variant.price as string integer (minor units, e.g. paise).
 */
(function () {
  function centsFromShopify(val) {
    if (val == null || val === '') return NaN;
    var s = String(val).trim();
    if (s.indexOf('.') !== -1) {
      var f = parseFloat(s);
      return isNaN(f) ? NaN : Math.round(f * 100);
    }
    var n = parseInt(s, 10);
    return isNaN(n) ? NaN : n;
  }

  function formatRupeeFromPaise(paise) {
    if (isNaN(paise) || paise < 0) return '₹0';
    return '₹' + (paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  /** Display price using first variant (matches Shopify storefront JSON). */
  function formatDisplayPrice(p) {
    var v0 = p.variants && p.variants[0];
    var raw = v0 && v0.price != null && v0.price !== '' ? v0.price : p.price;
    var cents = centsFromShopify(raw);
    if (isNaN(cents)) return '₹0';
    return formatRupeeFromPaise(cents);
  }

  function imgUrl(src, width) {
    if (!src) return '';
    if (String(src).indexOf('width=') !== -1) return src;
    return src + (String(src).indexOf('?') !== -1 ? '&width=' : '?width=') + width;
  }

  /**
   * Shopify JSON usually sends `available` as a boolean; if it ever comes as a string,
   * `"false"` is still truthy in JS — never use `if (v.available)` alone.
   */
  function variantIsPurchasable(v) {
    if (!v) return false;
    var a = v.available;
    if (a === true || a === 1) return true;
    if (a === false || a === 0) return false;
    if (typeof a === 'string') {
      var s = a.toLowerCase().trim();
      if (s === 'true' || s === '1') return true;
      if (s === 'false' || s === '0' || s === '') return false;
    }
    return false;
  }

  function productHasAnyPurchasable(product) {
    if (!product.variants || !product.variants.length) {
      var pa = product.available;
      if (pa === true || pa === 1) return true;
      if (typeof pa === 'string' && pa.toLowerCase().trim() === 'true') return true;
      return false;
    }
    return product.variants.some(function (x) {
      return variantIsPurchasable(x);
    });
  }

  function firstPurchasableVariant(product) {
    if (!product.variants || !product.variants.length) return null;
    var v = product.variants.find(function (x) {
      return variantIsPurchasable(x);
    });
    return v || null;
  }

  /** Same rules as snippets/kyros-product-card.liquid (NEW on image only). */
  function showNewBadge(product) {
    if (!product) return false;
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).toLowerCase().trim() === 'new') return true;
    }
    var created = product.created_at;
    if (!created) return false;
    var t = Date.parse(String(created));
    if (isNaN(t)) return false;
    var ageSec = (Date.now() - t) / 1000;
    return ageSec >= 0 && ageSec < 2592000;
  }

  function localeBase(root) {
    var p = root.getAttribute('data-locale-root') || '';
    return !p || p === '/' ? '' : p.replace(/\/$/, '');
  }

  /**
   * JSON products often use paths like /products/handle without the locale prefix.
   * On multilingual / market storefronts that sends users to the wrong URL (e.g. home).
   * Prefix with the same locale root used for /collections/.../products.json fetches.
   */
  function productHref(root, product) {
    if (!product) {
      return '#';
    }
    var u = product.url != null ? String(product.url).trim() : '';
    var h = product.handle != null ? String(product.handle).trim() : '';
    var base = localeBase(root);
    var path = '#';
    if (/^https?:\/\//i.test(u)) {
      path = u;
    } else if (u) {
      var up = u.indexOf('/') === 0 ? u : '/' + u;
      path = base + up;
    } else if (h) {
      path = base + '/products/' + encodeURIComponent(h);
    }
    return path.replace(/"/g, '&quot;');
  }

  function productsJsonUrl(root, handle, limit) {
    return localeBase(root) + '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + String(limit);
  }

  function cartJsUrl(root) {
    return localeBase(root) + '/cart.js';
  }

  function cartAddUrl() {
    var u = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return u.indexOf('.js') === -1 ? u + '.js' : u;
  }

  function updateCartBubbles(count) {
    var txt = count < 100 ? String(count) : '';
    document.querySelectorAll('.cart-count-bubble').forEach(function (wrap) {
      var num = wrap.querySelector('span[aria-hidden="true"]');
      if (num) num.textContent = count > 0 ? txt : '';
    });
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon && count > 0 && !cartIcon.querySelector('.cart-count-bubble')) {
      var bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML =
        '<span aria-hidden="true">' +
        txt +
        '</span><span class="visually-hidden">' +
        count +
        ' items in cart</span>';
      cartIcon.appendChild(bubble);
    }
  }

  function triggerCartRefresh(cart) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'snt-collections-grid',
          cartData: cart,
        });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  function productCreatedTs(p) {
    var d = p.created_at;
    if (!d) return 0;
    var t = Date.parse(String(d));
    return isNaN(t) ? 0 : Math.floor(t / 1000);
  }

  function newBadgeHtml(product) {
    if (showNewBadge(product)) {
      return '<span class="product-card__badge">NEW</span>';
    }
    return '';
  }

  function renderGrid(root, products) {
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var addLabel = root.getAttribute('data-i18n-add') || 'Add to cart';
    var chooseLabel = root.getAttribute('data-i18n-choose') || 'Choose options';
    var soldLabel = root.getAttribute('data-i18n-sold') || 'Sold out';

    products = (products || []).filter(productHasAnyPurchasable);
    products.sort(function (a, b) {
      return productCreatedTs(b) - productCreatedTs(a);
    });
    products = products.slice(0, limit);
    var grid = root.querySelector('.snt-cg__grid');
    if (!grid) return;

    grid.innerHTML = '';
    products.forEach(function (product) {
      var featured = product.featured_image;
      var src =
        typeof featured === 'string'
          ? imgUrl(featured, 900)
          : featured && featured.src
            ? imgUrl(featured.src, 900)
            : product.images && product.images[0]
              ? imgUrl(
                  typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src,
                  900,
                )
              : '';
      var price = formatDisplayPrice(product);
      var purl = productHref(root, product);
      var safeTitle = (product.title || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      var badgeHtml = newBadgeHtml(product);
      var variantCount = product.variants && product.variants.length ? product.variants.length : 0;

      var ctaHtml = '';
      if (!productHasAnyPurchasable(product)) {
        ctaHtml =
          '<button type="button" class="product-card__cta sold-out" disabled>' + soldLabel + '</button>';
      } else if (variantCount > 1) {
        ctaHtml = '<a href="' + purl + '" class="product-card__cta">' + chooseLabel + '</a>';
      } else {
        var v0 = firstPurchasableVariant(product);
        var vid = v0 ? v0.id : '';
        if (vid) {
          ctaHtml =
            '<button type="button" class="product-card__cta" data-variant-id="' +
            vid +
            '">' +
            addLabel +
            '</button>';
        } else {
          ctaHtml =
            '<button type="button" class="product-card__cta sold-out" disabled>' + soldLabel + '</button>';
        }
      }

      var mediaInner = '';
      if (src) {
        mediaInner =
          '<img class="product-card__img" src="' +
          src.replace(/"/g, '&quot;') +
          '" alt="' +
          safeTitle +
          '" loading="lazy" width="900" height="1200">';
      }

      var card = document.createElement('div');
      card.className = 'product-card';
      card.setAttribute('role', 'listitem');
      card.innerHTML =
        '<a href="' +
        purl +
        '" class="product-card__link">' +
        '<div class="product-card__media product-card__image-wrap">' +
        badgeHtml +
        mediaInner +
        '</div>' +
        '<div class="product-card__info">' +
        '<p class="product-card__title">' +
        safeTitle +
        '</p>' +
        '<p class="product-card__price">' +
        price +
        '</p>' +
        '</div></a>' +
        ctaHtml;

      grid.appendChild(card);
    });

    grid.querySelectorAll('button.product-card__cta[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id) return;
        addVariant(root, id, btn);
      });
    });
  }

  function addVariant(root, variantId, btn) {
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('snt-cg__loading');
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || 'Cart error');
        return fetch(cartJsUrl(root)).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        updateCartBubbles(cart.item_count);
        triggerCartRefresh(cart);
      })
      .catch(function (err) {
        alert(err.message || 'Could not add to cart');
      })
      .finally(function () {
        btn.removeAttribute('disabled');
        btn.classList.remove('snt-cg__loading');
      });
  }

  function loadCollection(root, handle, isFirst) {
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    var fetchLimit = Math.min(Math.max(limit * 8, 48), 250);
    var spinner = root.querySelector('.snt-cg__spinner');
    var viewLink = root.querySelector('.snt-cg__view-all-link');
    var grid = root.querySelector('.snt-cg__grid');

    if (spinner) spinner.hidden = false;
    if (grid && !isFirst) {
      grid.classList.add('snt-cg__grid--fading');
    }

    fetch(productsJsonUrl(root, handle, fetchLimit))
      .then(function (r) {
        if (!r.ok) throw new Error('Collection not found');
        return r.json();
      })
      .then(function (data) {
        renderGrid(root, data.products || []);
        if (viewLink) {
          var p = root.getAttribute('data-locale-root') || '';
          var base = !p || p === '/' ? '' : p.replace(/\/$/, '');
          viewLink.setAttribute('href', base + '/collections/' + encodeURIComponent(handle));
        }
        if (grid) {
          grid.classList.remove('snt-cg__grid--fading');
          if (!isFirst) {
            grid.classList.add('snt-cg__grid--enter');
            window.setTimeout(function () {
              grid.classList.remove('snt-cg__grid--enter');
            }, 450);
          }
        }
      })
      .catch(function () {
        if (grid) {
          grid.classList.remove('snt-cg__grid--fading');
          grid.innerHTML =
            '<p class="snt-cg__error">Could not load products. Check the collection handle in Shopify admin.</p>';
        }
      })
      .finally(function () {
        if (spinner) spinner.hidden = true;
      });
  }

  function tabArrowState(root) {
    var track = root.querySelector('.snt-cg__tabs-scroll');
    var prev = root.querySelector('.snt-cg__tabs-arrow--prev');
    var next = root.querySelector('.snt-cg__tabs-arrow--next');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    prev.hidden = track.scrollLeft <= 2;
    next.hidden = track.scrollLeft >= max;
  }

  function init(root) {
    if (!root || root.getAttribute('data-snt-cg-init')) return;
    root.setAttribute('data-snt-cg-init', '1');
    var active = root.querySelector('.snt-cg__tab[aria-selected="true"]');
    var handle = active ? active.getAttribute('data-handle') : '';
    var firstFetch = true;

    root.querySelectorAll('.snt-cg__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.getAttribute('aria-selected') === 'true') return;
        root.querySelectorAll('.snt-cg__tab').forEach(function (t) {
          t.setAttribute('aria-selected', 'false');
        });
        tab.setAttribute('aria-selected', 'true');
        firstFetch = false;
        loadCollection(root, tab.getAttribute('data-handle'), false);
      });
    });

    var track = root.querySelector('.snt-cg__tabs-scroll');
    var prev = root.querySelector('.snt-cg__tabs-arrow--prev');
    var next = root.querySelector('.snt-cg__tabs-arrow--next');
    if (track && prev && next) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -220, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: 220, behavior: 'smooth' });
      });
      track.addEventListener('scroll', function () {
        tabArrowState(root);
      });
      window.addEventListener('resize', function () {
        tabArrowState(root);
      });
      tabArrowState(root);
    }

    if (handle) loadCollection(root, handle, firstFetch);
  }

  function boot() {
    document.querySelectorAll('.snt-cg[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
